import React , { useRef } from 'react';
import {
    Show, 
    EditButton,
    SimpleShowLayout,
    CardActions,
    ListButton,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment'
import Card from '@material-ui/core/Card';
import ReactToPrint from "react-to-print";
import { makeStyles } from '@material-ui/core/styles';
import jwt_decode from 'jwt-decode'
import PrintIcon from '@material-ui/icons/Print';
import Printview from './PrintRegistration'
//import BarcodeCom from './BarcodeCom'
import ErrorBoundary from '../ErrorBoundary';

const RegistrationViewActions = ({ basePath, data }) => (
    <CardActions>
         <EditButton basePath={basePath} record={data} /> 
         <ListButton basePath={basePath} />
    </CardActions>
);

const styles = {
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    hidden: {
        display: 'none'
    }
};

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',            
        alignItems: 'middle'
    },

    title: {
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '90%',
        maxWidth: '800',
        alignItems: 'middle',
        border: 'double',
        fontSize: '14',
        fontWeight: 'bold'
    },

    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
       
    },
    image: {
        width: '60px',
        hight: '20px'
    }

});

const Title =({record}) =>{
    return <span>{record.last_name + ',  ' + record.first_name}</span>
}

const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <Printview record={record} classes={classes} ref={componentRef} />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
  };

const RegistrationView = ({ classes, ...props }) => (
    <center>
    <ErrorBoundary>
    <Show 
    {...props}  
    title="Registration view"
    actions={<RegistrationViewActions/>} 
    >     
        <SimpleShowLayout >     
        <Print />
        </SimpleShowLayout>     
    </Show>
    </ErrorBoundary>
    </center>
);

export default withStyles(styles)(RegistrationView);
  